import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const Analytics = (props: SvgProps) => (
  <Svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="32" height="32" rx="8" fill="#8B32A8" fillOpacity="0.05" />
    <rect
      x="0.25"
      y="0.25"
      width="31.5"
      height="31.5"
      rx="7.75"
      stroke="#8B32A8"
      strokeOpacity="0.2"
      strokeWidth="0.5"
    />
    <path
      d="M10 10V20.6667C10 21.0203 10.1405 21.3594 10.3905 21.6095C10.6406 21.8595 10.9797 22 11.3333 22H22M12.6667 18.6667C13 17.3333 13.6667 14 15.3333 14C16.6667 14 16.6667 16 18 16C19.6667 16 21 12.6667 21.3333 11.3333"
      stroke="#8B32A8"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default Analytics;
